import PropTypes from "prop-types";
import React, { useState } from "react";
import { setActiveSort } from "../../helpers/product";
import { Collapse } from "react-collapse";
import { Link } from "react-router-dom";
import { useEffect } from "react";

const ShopBrands = ({ brands, getSortParams }) => {
  //const [stateLista, setstateLista] = useState(global.aziendaID == 1? true : false);
  const [stateLista, setstateLista] = useState(false);
  const [brandSelected, setBrandSelected] = useState(
    JSON.parse(sessionStorage.getItem("filter"))?.brands?.split("|")
  );
  const [refresh, setRefresh] = useState(true);

  const CambioStato = () => {
    if (stateLista) setstateLista(false);
    else setstateLista(true);
  };

  useEffect(() => {
    setBrandSelected(
      JSON.parse(sessionStorage.getItem("filter"))?.brands?.split("|")
    );
    setRefresh(!refresh);
  }, [sessionStorage.getItem("filter")]);

  return (
    <div className="sidebar-widget">
      <div
        data-role="title"
        role="tab"
        aria-selected="false"
        aria-expanded="false"
        tabindex="-1"
        onClick={() => CambioStato()}
        style={{
          fontSize: "17px",
          color: "black",
          fontWeight: 600,
          cursor: "pointer",
          lineHeight: "30px",
        }}
      >
        <span
          class={
            stateLista
              ? "icon pe-7s-angle-down pull-right"
              : "icon pe-7s-angle-up pull-right"
          }
          data-role="icons"
          style={{ display: "inline-block" }}
        >
          {" "}
        </span>
        Marchi
      </div>

      {/*<div className="shopping-cart-btn btn-hover text-center" style={{ padding: "10px" }}>
        <a style={{ padding: "10px", border: "1px gray solid", display: "block", width: "100%" }} onClick={() => CambioStato()}  >Marchi</a>
  </div>*/}
      {/* <h4  <h4 className="btn btn-primary btn-xs" onClick={() => CambioStato()}>Marchi </h4>*/}
      <Collapse
        theme={{ collapse: "foo", content: "bar" }}
        isOpened={stateLista}
      >
        <div className="sidebar-widget-tag">
          {brands ? (
            <ul>
              <li>
                <div className="sidebar-widget-list-left">
                  <button
                    id="allBrands"
                    onClick={(e) => {
                      document
                        .querySelectorAll(".brands")
                        .forEach((element) =>
                          element.classList.remove("active")
                        );
                      if (e.currentTarget.classList.contains("active"))
                        getSortParams("brands", "all", "-");
                      else getSortParams("brands", "all", "+");
                      //getSortParams("brands", "");
                      setActiveSort(e);
                    }}
                  >
                    <span className="checkmark" /> Tutti i marchi
                  </button>
                </div>
              </li>
              {brands.map((brands, key) => {
                if (brands === "") return;
                return (
                  <li key={key}>
                    <div className="sidebar-widget-list-left">
                      <button
                        className={
                          "brands " +
                          (brandSelected?.find((v) => brands === v)
                            ? "active"
                            : "")
                        }
                        onClick={(e) => {
                          document
                            .querySelector("#allBrands")
                            .classList.remove("active");
                          if (e.currentTarget.classList.contains("active"))
                            getSortParams("brands", brands, "-");
                          else getSortParams("brands", brands, "+");
                          //getSortParams("brands", brands);
                          setActiveSort(e);
                        }}
                      >
                        {" "}
                        <span className="checkmark" /> {brands}{" "}
                      </button>
                    </div>
                  </li>
                );
              })}
            </ul>
          ) : (
            ""
          )}
        </div>
      </Collapse>
    </div>
  );
};

ShopBrands.propTypes = {
  brands: PropTypes.array,
  getSortParams: PropTypes.func,
};

export default ShopBrands;
